import React from 'react';

const Footer = () => {
  return (
    <footer className='main-footer'>
      <div
        style={{
          borderBottom: '5px solid',
          borderColor: '#CEA538',
          width: '98%',
          margin: '0 auto',
        }}
      ></div>
      <div className='container mt-4'>
        <div className='row'>
          {/* Brand + contact */}
          <div className='col-md-4 col-sm-12 mb-4'>
            <p className='m-footer-logo'>
              <img src='images/coin-bazzar1.png' width='177px' height='45' />
            </p>
            <div className='m-footer-txt1'>
              <div>
                <img
                  src='images/phone3.png'
                  id='wa-hover'
                  width={20}
                  alt='Whatsapp Icon'
                  title='Whatsapp Icon'
                ></img>{' '}
                <a href='mailto:support@ebullion.in' style={{ color: 'black' }}>
                  +91 81698 60012
                </a>
              </div>
              <div className='mt-2'>
                <img
                  src='images/mail4.png'
                  id='wa-hover'
                  width={20}
                  alt='Whatsapp Icon'
                  title='Whatsapp Icon'
                ></img>{' '}
                <a href='mailto:support@ebullion.in' style={{ color: 'black' }}>
                  info@coinbazaar.in
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className='col-md-3 col-sm-6 col-6 mb-4'>
            <h6 className='footer-col-title'>Quick Links</h6>
            <ul className='footer-link-list'>
              {/* <li>
                <a href='/'>Home</a>
              </li> */}
              <li>
                <a href='/sip'>SIP</a>
              </li>
              <li>
                <a href='/multimetal-sip'>Multimetal SIP</a>
              </li>
              <li>
                <a href='/redeem-coins-bars'>Redeem eBullion Gold / Silver Bar</a>
              </li>
               <li>
                <a href='/redeem-coins-bars'>Buy Bullion on CoinBazaar</a>
              </li>
              <li>
                <a href='/price-charts'>Price Charts</a>
              </li>
            </ul>
          </div>

          {/* Company / Legal */}
          <div className='col-md-3 col-sm-6 col-6 mb-4'>
            <h6 className='footer-col-title'>Company</h6>
            <ul className='footer-link-list'>
              <li>
                <a href='/trustee-certificate'>Trustee Certificate</a>
              </li>
              <li>
                <a href='/faq'>FAQs</a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className='col-md-2 col-sm-12 mb-4'>
            <h6 className='footer-col-title'>Follow Us</h6>
            <p className='social-icons'>
              <a
                href='https://www.facebook.com/CoinBazaar.in'
                target='_blank'
                onMouseOut='MM_swapImgRestore()'
                onMouseOver="MM_swapImage('Image1','','images/f-icon-hover.png',1)"
              >
                <img src='images/f-icon.png' id='Image1' />
              </a>
              <a
                href='https://twitter.com/coin_bazaar'
                target='_blank'
                onMouseOut='MM_swapImgRestore()'
                onMouseOver="MM_swapImage('Image2','','images/t-icon-hover.png',2)"
              >
                <img src='images/t-icon.png' id='Image2' />
              </a>
              <a
                href='https://www.instagram.com/coin_bazaar/'
                target='_blank'
                onMouseOut='MM_swapImgRestore()'
                onMouseOver="MM_swapImage('Image3','','images/i-icon-hover.png',3)"
              >
                <img src='images/i-icon.png' id='Image3' />
              </a>
            </p>
          </div>
        </div>

        <div className='footer-bottom-bar'>
          &copy; {new Date().getFullYear()} CoinBazaar powered by eBullion. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
